/*
 * ChurchMouse
 * Enhanced By: Dave Lazar
 * Resistor Software Inc.
 * (c) 2011, 2012, 2013
*/
if (typeof(console) == 'undefined') {
    var console = {
        log: function() {},
        info: function() {},
        warn: function() {},
        error: function() {},
        time: function() {}
    }
}
else if (typeof(console.log) == 'undefined') {
    console.log = function() {};
}

if (!window.localStorage) {
  window.localStorage = {
    getItem: function (sKey) {
      if (!sKey || !this.hasOwnProperty(sKey)) { return null; }
      return unescape(document.cookie.replace(new RegExp("(?:^|.*;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"), "$1"));
    },
    key: function (nKeyId) {
      return unescape(document.cookie.replace(/\s*\=(?:.(?!;))*$/, "").split(/\s*\=(?:[^;](?!;))*[^;]?;\s*/)[nKeyId]);
    },
    setItem: function (sKey, sValue) {
      if(!sKey) { return; }
      document.cookie = escape(sKey) + "=" + escape(sValue) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
      this.length = document.cookie.match(/\=/g).length;
    },
    length: 0,
    removeItem: function (sKey) {
      if (!sKey || !this.hasOwnProperty(sKey)) { return; }
      document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      this.length--;
    },
    hasOwnProperty: function (sKey) {
      return (new RegExp("(?:^|;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    }
  };
  window.localStorage.length = (document.cookie.match(/\=/g) || window.localStorage).length;
}

// establish ChurchMouse object
if (!ChurchMouse) {
  var ChurchMouse = {
    cart: [],
    variants: [],
    defaults: {}
  }
}

// ChurchMouse factory
ChurchMouse.utils = function () {
  var product = null;
  var products = [];
  var cart = null;
  var queue = []; // added to make Assistant work
  var clone;
  var bundle = {};
  var bundleStatus = false;
  var current;
  var others = {};
  var items = {};

  var counter = {
    normalOutOfStock: 0,
    bundles: {},
    handles: {},
    variants: {},
    tally: {},
    hidden: {}
  }

  return {

    // given a product handle, find all the bundles that currently have that handle
    bundleCheck : function(handle, p) {
      _.each(counter.bundles, function(bundle, key){
        var f = _.filter(bundle, function(b){
          return b.handle == handle;
        });
        if(f.length) {
          _.each(f, function(o){
            _.each(p.variants, function(v){
              if(v.inventory_quantity < o.multiplier && v.id == o.id) {
                console.log("Not enough inventory of product ", v.id, key);
                counter.hidden[key] = true;
                //$(".variant_"+key).hide();
                $(".variant_"+key).addClass('out-of-stock'); // added march 2016
              }
            });
          });
        }
      });
    },

    pushItem : function(handle, product) {
      items[handle] = product;
    },

    getItems : function() {
      return items;
    },

    getItem : function(handle) {
      return items[handle];
    },

    getProducts : function () {
      return products;
    },

    addBundle : function(id, data) {
      counter.bundles[id] = data;
    },

    getBundleById : function(id) {
      console.log("Bundles: %o", counter.bundles);
      return counter.bundles[id];
    },

    clearTally : function () {
      counter.tally = {};
    },

    // add up all instances of one particular variant.
    addTally : function(id, amount) {
      console.log("Before: ", counter.tally);
      if(_.has(counter.tally, id)){
        counter.tally[id] += amount;
        console.log("Added to existing key", id);
      } else {
        counter.tally[id] = amount;
        console.log("Create new key",id);
      }
      console.log("After: ", counter.tally);
    },

    getTally : function() {
      return counter.talley;
    },

    addToCounter : function(key, id) {
      if(_.has(counter[key], id)){
        counter[key][id] += 1;
      } else {
        counter[key][id] = 1;
      }
    },

    getCounter : function() {
      return counter;
    },

    resetOther : function (){
      others = {};
    },

    setOther : function(key, value) {
      others[key] = value;
    },

    getOther: function(key) {
      return others[key];
    },

    setBundle: function(b) {
      $.extend(bundle,b);
    },

    getBundle: function() {
      return bundle;
    },

    addNormalOutOfStock : function() {
      counter.normalOutOfStock += 1;
    },

    getNormalOutOfStock : function() {
      return counter.normalOutOfStock;
    },

    setBundleStatus : function(status) {
      bundle.status = status;
    },

    getBundleStatus : function() {
      return bundle.status;
    },

    getBundleQuantity: function() {
      return bundle.quantity;
    },

    getBundleCallback: function() {
      return bundle.callback;
    },

    setCurrent : function(obj) {
      current = obj;
    },

    getCurrent : function() {
      return current;
    },

    getHidden : function() {
      return Object.keys(counter.hidden).length;
    },

    cloneQ: function() {
      clone = _.clone(queue);
    },

    getQ : function() {
      return queue;
    },

    pushQ : function(obj) {
      queue.push(obj);
    },

    popQ : function() {
      return clone.pop();
    },

    setCart : function (c) {
      cart = c;
    },
    getCart : function () {
      return cart;
    },
    setProduct: function (p) {
      product = p;
    },
    getProduct: function () {
      return product;
    },

    getVariant : function(id) {
      var variant = "";
      $.each(product.variants, function(idx, v){
        if (v.id == id) {
          variant = v;
          return false;
        }
      });
      return variant;
    },

    getOriginalPrice: function () {
      return product.price;
    },

    // new function to decide when to show/hide the sold out button
    hideAll : function() {
      var hidden = counter.normalOutOfStock + Object.keys(counter.hidden).length;
      if(product.variants.length == hidden) {
        $("#purchase").hide();
        $("#subtotal").hide();
        if(_.contains(product.tags, "comingsoon")) {
          $("#coming_soon").show();
        } else {
          $("#sold_out").show();
        }
      }
    }

  }
}();

// add to plugins here
(function ($) {

  $.getVariantImage = function(img, ext) {
    var regex = new RegExp(img+ext);
    var result = "";
   $("#product_image_library img").each(function(idx,val){
     if($(this).attr("src").match(regex)) {
       result = $(this).attr("src");
       return false;
     }
   });
   return result;
  }
})(jQuery);